export default class NodeError extends Error {
  constructor(public readonly nodeId: string, public readonly nodeType: string, message?: string) {
    super(message);
  }
}
